import React from 'react';
export function PainSection() {
  return <section className="bg-white px-4 py-4" data-id="element-118" data-mp="1rs46ptzpuxd9">
      <div className="mx-auto max-w-3xl rounded-xl border-l-[6px] border-ev-green bg-ev-paper p-3.5 sm:p-5" data-id="element-119" data-mp="38ygfc8hvsmmc">
        <h2 className="mb-2 font-display text-[19px] leading-tight text-ev-black sm:text-[26px]" data-id="element-120" data-mp="2uyx8rk4pxjc5">
          😩 Stop Searching Through Different References for Every Fault
        </h2>
        <p className="text-[13px] font-medium leading-snug text-ev-black/80 sm:text-[15px]" data-id="element-121" data-mp="2l8m2vs1h502m">
          You already understand automotive diagnostics. The problem is wasting time jumping between
          scattered information, diagrams and system references to understand what needs checking
          next. Open the system, identify the symptom and follow the relevant diagnostic path.{' '}
          <span className="font-extrabold text-ev-black" data-id="element-122" data-mp="229qa8l59ktqw">
            Less guessing. More structured diagnostics.
          </span>
        </p>
      </div>
    </section>;
}